import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZulipComponent } from './simple-icons-zulip.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZulipComponent ],
    exports:      [ SimpleIconsZulipComponent ],
    bootstrap:    []
})
export class SimpleIconsZulipModule {}
